import React, { useState } from 'react'
import { Button, Modal } from '@vzmi/shp_shared_compo'
import { DetailTable } from '../../../Proposal/Common/ItemIdClipBoard/ItemSpecDetailTable'
import styles from './BtnModal.css'

const BtnModal = props => {
  const {
    btnProps,
    tableProps
  } = props

  const [showModal, setShowModal] = useState(false)

  const toggleShowModal = () => setShowModal(prevShowModal => !prevShowModal)

  const {
    btnChildren,
    ...otherBtnProps
  } = btnProps

  return (
    <span className={styles.BtnModal}>
      <span>
        <Button
          type='primary'
          buttonType='outline'
          className={styles.btn}
          onClick={toggleShowModal}
          {...otherBtnProps}
        >
          {btnChildren}
        </Button>
      </span>
      <Modal
        closable
        maskClosable
        keyboard
        disableFooter
        destroyOnClose
        title={btnChildren}
        visible={showModal}
        onCancel={toggleShowModal}
        width={720}
        style={{
          maxHeight: 560
        }}
      >
        <DetailTable
          {...tableProps}
        />
      </Modal>
    </span>

  )
}

export default BtnModal
